import type { ReactNode } from 'react'
import React from 'react'
import style from './Footer.module.sass'

type FooterColumnProps = {
	title: string
	content: ReactNode
}

export const FooterColumn = React.memo(function FooterColumn(props: FooterColumnProps) {
	return (
		<div className={style.footerColumn}>
			<h3 className={style.title}>{props.title}</h3>
			{props.content}
		</div>
	)
})
